<template>
    <div class="page-wrapper flex margin-left-sm" v-loading="loading">
        <div class="flex flex-direction flex-sub">
            <div class="flex flex-direction bg-white radius padding-sm">
                <div class="classify-title">项目统计</div>
                <div class="flex margin-top-xs">
                    <div class="total-container linear-gradient-yellow max flex flex-direction justify-center flex-sub">
                        <div class="label">项目总数</div>
                        <div class="number">{{ project_count.total_num }}</div>
                        <el-image class="icon max" :src="require('@/assets/img/total/icon_project_classify_1.png')"></el-image>
                    </div>
                    <div class="flex flex-direction flex-sub margin-lr-xs">
                        <div class="total-container linear-gradient-green flex flex-direction justify-center flex-sub">
                            <div class="label">已结项</div>
                            <div class="number">{{ project_count.finish_num }}</div>
                            <el-image class="icon" :src="require('@/assets/img/total/icon_project_classify_5.png')"></el-image>
                        </div>
                        <div class="total-container linear-gradient-blue flex flex-direction justify-center flex-sub margin-top-xs">
                            <div class="label">委托单位</div>
                            <div class="number">{{ project_count.weituo_num }}</div>
                            <el-image class="icon" :src="require('@/assets/img/total/icon_project_classify_2.png')"></el-image>
                        </div>
                    </div>
                    <div class="flex flex-direction flex-sub">
                        <div class="total-container linear-gradient-light-green flex flex-direction justify-center flex-sub">
                            <div class="label">在执行</div>
                            <div class="number">{{ project_count.ongoing_num }}</div>
                            <el-image class="icon" :src="require('@/assets/img/total/icon_project_classify_4.png')"></el-image>
                        </div>
                        <div class="total-container linear-gradient-light-blue flex flex-direction justify-center flex-sub margin-top-xs">
                            <div class="label">成果汇</div>
                            <div class="number">{{ project_count.ongoing_num }}</div>
                            <el-image class="icon" :src="require('@/assets/img/total/icon_project_classify_3.png')"></el-image>
                        </div>
                    </div>
                </div>
            </div>
<!--            <div class="flex flex-direction bg-white radius padding-sm margin-top-xs">-->
<!--                <div class="classify-title">辅助资料</div>-->
<!--                <div class="file-total flex margin-top-xs">-->
<!--                    <div class="total-item flex flex-direction justify-center align-center" v-for="(item,index) in file_total_lists" :key="index">-->
<!--                        <div class="number">{{ item.num }}</div>-->
<!--                        <div class="label">{{ item.name }}</div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <div class="flex flex-direction flex-sub bg-white radius padding-sm margin-top-xs">
                <div class="classify-title">执行中项目</div>
                <empty v-if="!project_lists.length" class="self-center" size="min"></empty>
                <div class="list max">
                    <div class="project-item margin-top-sm flex align-center justify-between" v-for="(item,index) in project_lists" :key="index">
                        <div class="flex flex-direction">
                            <div class="title">{{ item.p_name }}</div>
                            <div class="flex align-center margin-top-sm">
                                <div class="classify" v-for="(tag,position) in item.cate_name" :key="position">{{ tag }}
                                </div>
                                <div class="time" v-if="item.end_time">{{ item.start_time }} - {{ item.end_time }}</div>
                            </div>
                        </div>
                        <div class="flex align-center">
                            <div class="flex flex-direction align-center">
                                <el-progress type="circle" :stroke-width="3" :width="42" :percentage="Number(item.taskLv)" :color="customColors"></el-progress>
                                <div class="percentage margin-top-xs">执行进度</div>
                            </div>
                            <div class="flex flex-direction align-center margin-left-sm">
                                <el-progress type="circle" :stroke-width="3" :width="42" :percentage="Number(item.timeLv)" :color="customColors"></el-progress>
                                <div class="percentage margin-top-xs">时间进度</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex flex-direction flex-sub margin-left-xs">
            <div class="flex flex-direction bg-white radius padding-sm">
                <div class="classify-title">任务统计</div>
                <div class="flex margin-top-xs">
                    <div class="total-container blue max flex flex-direction justify-center flex-sub">
                        <div class="task_number">{{ count.allTask }}</div>
                        <div class="task_label">任务总量</div>
                        <el-image class="water-ripple" :src="require('@/assets/img/total/icon_water_ripple.png')"></el-image>
                    </div>
                    <div class="flex flex-direction flex-sub margin-lr-xs">
                        <div class="total-container purple flex flex-direction justify-center flex-sub">
                            <div class="task_number">{{ count.underway }}</div>
                            <div class="task_label">进行中</div>
                            <el-image class="water-ripple" :src="require('@/assets/img/total/icon_water_ripple.png')"></el-image>
                        </div>
                        <div class="total-container red flex flex-direction justify-center flex-sub margin-top-xs">
                            <div class="task_number">{{ count.reject }}</div>
                            <div class="task_label">驳回/ 逾期</div>
                            <el-image class="water-ripple" :src="require('@/assets/img/total/icon_water_ripple.png')"></el-image>
                        </div>
                    </div>
                    <div class="flex flex-direction flex-sub">
                        <div class="total-container light-blue flex flex-direction justify-center flex-sub">
                            <div class="task_number">{{ count.toReview }}</div>
                            <div class="task_label">评审中</div>
                            <el-image class="water-ripple" :src="require('@/assets/img/total/icon_water_ripple.png')"></el-image>
                        </div>
                        <div class="total-container green flex flex-direction justify-center flex-sub margin-top-xs">
                            <div class="task_number">{{ count.finish }}</div>
                            <div class="task_label">已完成</div>
                            <el-image class="water-ripple" :src="require('@/assets/img/total/icon_water_ripple.png')"></el-image>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-direction flex-sub bg-white radius padding-sm margin-top-xs flex-sub">
                <div class="flex align-center justify-between">
                    <div class="flex align-center">
                        <div class="classify-title">工作提醒</div>
                        <div class="remind-tips flex align-center">
                            <div class="flex align-center margin-left"><i class="blue van-badge--dot"></i>新任务</div>
                            <div class="flex align-center margin-left-xs"><i class="green van-badge--dot"></i>进行中</div>
                            <div class="flex align-center margin-left-xs"><i class="yellow iconfont icon-shandian"></i>紧急任务
                            </div>
                            <div class="flex align-center margin-left-xs"><i class="red van-badge--dot"></i>已逾期</div>
                        </div>
                    </div>
                    <el-date-picker
                        class="remind-month cursor"
                        :editable="false"
                        v-model="dateMonth"
                        type="month"
                        format="yyyy 年 MM 月"
                        placeholder="选择月" @change="dateChange">
                    </el-date-picker>
                </div>
                <el-calendar v-model="dateMonth" :first-day-of-week="7">
                    <template
                        slot="dateCell"
                        slot-scope="{date, data}">
                        <el-popover
                            placement="bottom-start"
                            width="250"
                            trigger="hover" :disabled="reminds && reminds[data.day] && !reminds[data.day].fabu.length && !reminds[data.day].jinxing.length && !reminds[data.day].daoqi.length && !reminds[data.day].yuqi.length">
                            <div class="list" v-if="reminds && reminds[data.day]">
                                <div v-for="(item,index) in [...reminds[data.day].fabu,...reminds[data.day].daoqi,...reminds[data.day].jinxing,...reminds[data.day].yuqi]" :key="index"
                                     class="task-item flex align-center justify-between">
                                    <router-link class="flex align-center justify-between w-100" :to="`/web/staff/project/report/${item.p_id}/${item.pro_name}`"  v-if="item.type === 3">
                                        <div class="flex flex-direction margin-right-xs">
                                            <div class="title cursor">{{ item.name }}</div>
                                            <div class="time margin-top-xs">{{ item.create_time }}</div>
                                        </div>
                                        <div class="time flex-shrink" :class="item.end_day | end_day_color">{{ item.end_day | end_day }}</div>
                                    </router-link>
                                    <template v-else>
                                        <div class="flex flex-direction margin-right-xs">
                                            <div class="title cursor" @click="showApply(item)" v-if="item.type === 2">{{ item.name }}</div>
                                            <div class="title cursor" @click="finishTask(item)" v-else>{{ item.pro_name }}</div>
                                            <div class="time margin-top-xs">{{ item.create_time }}</div>
                                        </div>
                                        <div class="time flex-shrink" :class="item.end_day | end_day_color">{{ item.end_day | end_day }}</div>
                                    </template>

                                </div>
                            </div>
                            <div class="el-calendar-day_time flex flex-direction align-center" slot="reference">
                                <div class="time">{{ data.day.split('-').pop() }}</div>
                                <div class="remind-tips flex align-center margin-top-xs" v-if="reminds && reminds[data.day]">
                                    <!--                                {{reminds[data.day] ? reminds[data.day].fabu.length : 0}}-->
                                    <i class="blue van-badge--dot margin-left-xs" v-if="reminds[data.day].fabu.length || reminds[data.day].daoqi.length"></i>
                                    <i class="green van-badge--dot margin-left-xs" v-if="reminds[data.day].jinxing.length"></i>
                                    <i class="yellow iconfont icon-shandian margin-left-xs" v-if="reminds[data.day].jinxing.filter(f=>{ return f.type ===1 && f.level === 1}).length
                                || reminds[data.day].daoqi.filter(f=>{ return f.type ===1 && f.level === 1}).length
                                || reminds[data.day].fabu.filter(f=>{ return f.type ===1 && f.level === 1}).length"></i>
                                    <i class="red van-badge--dot margin-left-xs" v-if="reminds[data.day].yuqi.length"></i>
                                </div>
                            </div>
                        </el-popover>

                    </template>
                </el-calendar>
            </div>
        </div>

        <task-finish-dialog :dialog-visible="finishTaskDialog" :tid="cur_task_id" @watchState="watchState"></task-finish-dialog>
        <task-detail-task-dialog :dialog-visible="addTaskDetailDialog" :readonly="false" :tid="cur_task_id" @watchDetailState="watchDetailState"></task-detail-task-dialog>
    </div>
</template>

<script>

import {
    getProjectCountInfo,
    getProjectList,
    getProjectTotal,
    getStatisticsTaskThisMonth
} from "@/api";
import TaskDetailTaskDialog from "@/views/web/staff/components/TaskDetailTaskDialog";
import TaskFinishDialog from "@/views/web/staff/components/TaskFinishDialog";
import {customColors} from "@/utils/const";
import {filterDate, zhDate} from "@/utils/utils";

export default {
    name: "index",
    components: {TaskFinishDialog, TaskDetailTaskDialog},
    data() {
        return {
            customColors: customColors,
            project_count: '',
            project_lists: [],

            file_total_lists: [],

            count: '',

            reminds: '',
            dateMonth: new Date(),

            cur_task_id: 0,
            finishTaskDialog: false,
            addTaskDetailDialog: false,
            loading: false,
        }
    },
    created() {
        this.$emit('setIndex', [0,11], '首页', false)
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    mounted() {
    },
    methods: {
        async init() {
            this.loading = true
            let _data = await getProjectList('', '', '', '', '',
                '', '', 2, '', '', 1, 10000)
            _data.data.data.map(item => {
                item.end_time = filterDate(item.end_time)
                item.cate_name = item.cate_name ? item.cate_name.split(',') : []
            })
            this.project_lists = _data.data.data
            _data = await getProjectTotal()
            this.project_count = _data.data

            _data = await getProjectCountInfo()
            this.count = _data.data

            // _data = await getStatisticsFileNum()
            // this.file_total_lists = _data.data
            this.loading = false
            await this.getStatisticsTaskThisMonth()
        },

        async getStatisticsTaskThisMonth() {
            this.loading = true
            let _data = await getStatisticsTaskThisMonth(zhDate(this.dateMonth, 5))
            this.reminds = _data.data
            this.loading = false
        },

        showApply(data) {
            this.$router.push(`/web/admin/apply/review/${data.p_id}`)
        },
        showTask(data) {
            this.cur_task_id = data.id
            this.addTaskDetailDialog = true
        },
        finishTask(data) {
            this.cur_task_id = data.id
            this.finishTaskDialog = true
        },
        watchState(data) {
            if (data) this.init()
            this.cur_task_id = 0
            this.finishTaskDialog = false
        },
        watchDetailState(data) {
            this.init()
            if (!data) {
                this.cur_task_id = 0
                this.addTaskDetailDialog = false;
            }
        },
        dateChange() {
            this.getStatisticsTaskThisMonth()
        }
    },
    filters: {
        end_day(val) {
            if (val === 0) {
                return '今天截止'
            } else if (val === 1) {
                return `明天截止`
            } else if (val < 0) {
                return `已逾期${Math.abs(val)}天`
            } else {
                if (Number(val)) {
                    return `${Math.abs(val)}天截止`;
                } else {
                    return `${val}小时截止`;
                }

            }
        },
        end_day_color(val) {
            if (val === 0) {
                return `text-dg`
            } else if (val === 1) {
                return `text-dg`
            } else if (val < 0) {
                return `text-red`
            } else {
                return `text-dg`
            }
        }
    }

}
</script>

<style lang="scss" scoped>

/deep/ {

    .el-popover{
        border-radius:10px;
        background-color: #ffffff;
        box-shadow: 0px 0px 13px 0px
        rgba(219, 226, 232, 0.69);
        padding: 0;

    }
    .el-loading-mask {
        background-color: rgba(255, 255, 255, 0.1);
    }

    .el-calendar__header {
        display: none;
    }

    .el-calendar__body {
        padding: 0;
    }

    .el-calendar-table {
        border-collapse: inherit;
        border-spacing: 10px;

        .prev, {
            visibility: hidden;
        }

        .next {
            display: none;
        }

        .current {
            width: 97px;
            height: 62px;
            background-color: #ffffff;
            border-radius: 10px;
            border: solid 1px #edf5fc;

            .el-calendar-day {
                &:hover {
                    background: none;
                }
            }

            &.is-today {
                .el-calendar-day_time {
                    .time {
                        color: #fff;
                        background-color: #1c3fbf;
                    }
                }
            }

            .el-calendar-day_time {
                width: 100%;
                height: 100%;
                padding: 13px 12px;

                .time {
                    font-size: 19px;
                    color: #0a2240;
                    min-width: 25px;
                    height: 25px;
                    line-height: 25px;
                    padding: 0 6px;
                    border-radius: 10px;
                }
            }
        }
    }

    thead {
        th {
            // 修改头部星期部分
            font-size: 16px;
            font-weight: 600;
            color: #0a2240;

            &:first-child, &:last-child {
                color: #5d6ca2;
            }
        }
    }

    .remind-month .el-input__prefix,
    .remind-month .el-input__suffix {
        display: none;
    }

    .remind-month.el-date-editor.el-input {
        width: auto;
    }

    .remind-month .el-input__inner {
        font-size: 16px;
        font-weight: 600;
        color: #1c3fbf;
        border: none;
        text-align: right;
        cursor: pointer;
    }

}

.list {
    max-height: 600px;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 6px;
        height: 10px;
        /*background-image: var(--gradualRed);*/
    }

    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #f6f6f6;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        width: 5px;
        height: 10px;
        background: #999999;
    }

    &.max {
        max-height: 550px;
    }
}
.task-item{
    .title{
        font-size: 14px;
        font-weight: 600;
        color: #0a2240;
    }
    .time{
        font-size: 12px;
        color: #7485a1;
    }

}
.task-item+.task-item{
    border-top:  solid 1px #edf5fc;
    padding-top: 10px;
}
.page-wrapper {
    .classify-title {
        font-size: 16px;
        font-weight: 600;
        color: #0a2240;
    }


    .file-total {
        height: 85px;

        .total-item {
            height: 100%;
            background-image: linear-gradient(90deg, #deeeff 0%, #f9fcff 100%);
            background-blend-mode: normal, normal;
            border-radius: 10px;

            .number {
                font-size: 22px;
                font-weight: 600;
                color: #345e91;
            }

            .label {
                font-size: 14px;
                color: #345e9196;
                margin-top: 10px;
            }

            &:not(:first-child) {
                flex: 1;
            }

            &:first-child {
                width: 246px;
                background-image: linear-gradient(90deg, #5697d9 0%, #6493d1 100%);

                .number {
                    color: #ffffff;
                }

                .label {
                    color: #ffffff;
                }
            }

        }

        .total-item + .total-item {
            margin-left: 10px;
        }
    }

    .remind-tips {
        i {
            margin-right: 5px;
        }

        .blue {
            background: #1c3fbf;
        }

        .green {
            background: #45d0cd;
        }

        .yellow {
            color: #ff9600;
        }

        .red {
            background: #ef283b;
        }

        font-size: 14px;
        color: #333333;
    }

    .project-item {
        background-color: #ffffff;
        border-radius: 10px;
        border: solid 1px #edf5fc;
        padding: 30px 25px;

        .title {
            font-size: 14px;
            font-weight: 600;
            color: #0a2240;
        }

        .classify {
            min-width: 57px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            padding: 0 6px;
            background-color: #ff9600;
            border-radius: 10px;
            font-size: 12px;
            color: #ffffff;
            margin-right: 10px;
        }

        .time, .percentage {
            font-size: 12px;
            color: #7485a1;
        }

        .progress {

        }
    }

    .total-container {
        border-radius: 10px;
        padding: 20px 35px;
        position: relative;
        background-blend-mode: normal, normal;

        &.max {
            height: 271px;
        }

        &.linear-gradient-yellow {
            background-image: linear-gradient(90deg, #ff8400 0%, #ffc000 100%);
        }

        &.linear-gradient-green {
            background-image: linear-gradient(90deg, #00cb9e 0%, #8cffac 100%);
        }

        &.linear-gradient-blue {
            background-image: linear-gradient(90deg, #04459d 0%, #0769ee 100%);
        }

        &.linear-gradient-light-green {
            background-image: linear-gradient(90deg, #09bda6 0%, #75efe2 100%);
        }

        &.linear-gradient-light-blue {
            background-image: linear-gradient(90deg, #0080e3 0%, #4adbff 100%);
        }

        &.blue {
            background-image: linear-gradient(90deg, #0152c0 0%, #4292ff 98%);
        }

        &.purple {
            background-image: linear-gradient(90deg, #8a45f1 0%, #c388ff 98%);
        }

        &.red {
            background-image: linear-gradient(90deg, #f2106a 0%, #ff81a8 100%);
        }

        &.light-blue {
            background-image: linear-gradient(90deg, #0080e3 0%, #4adbff 100%);
        }

        &.green {
            background-image: linear-gradient(90deg, #0dabb5 0%, #75efe2 100%);
        }

        .label {
            font-size: 20px;
            font-weight: 600;
            color: #ffffff;
        }

        .number {
            font-size: 36px;
            line-height: 36px;
            font-weight: 600;
            color: #ffffff;
            margin-top: 30px;
        }

        .task_number {
            font-size: 36px;
            line-height: 36px;
            font-weight: 600;
            color: #ffffff;
        }

        .task_label {
            font-size: 20px;
            color: #ffffff;
            margin-top: 30px;
        }

        .icon {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 106px;

            &.max {
                width: 132px;
            }
        }

        .water-ripple {
            position: absolute;
            bottom: 20px;
            right: 0;
            width: 100%;
        }
    }
}
</style>
